import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import { partnersData } from '../../data';
import { useAuth } from '../../store/auth';

const Partners = () => {
    const { isArabic } = useAuth();
    
    return (
        <React.Fragment>
            <Container>
                <Row className="justify-content-center mb-4">
                    <Col className="text-center">
                        <h5 className="text-muted">
                            {!isArabic ? 'موثوق بها من قبل الشركات الرائدة' : 'Trusted by Leading Companies'}
                        </h5>
                    </Col>
                </Row>
                <Row className="justify-content-center">
                    {partnersData.map((item, key) => (
                        <Col key={key} lg={2} md={3} className="col-6 text-center py-4">
                            <img
                                src={item.img}
                                className="avatar avatar-ex-sm center partner-logo" 
                                alt={`Partner Logo ${key + 1}`}
                                style={{ height: '60px', objectFit: 'contain' }}
                            />
                        </Col>
                    ))}
                </Row>
            </Container>
        </React.Fragment>
    );
};

export default Partners;